export default __webpack_public_path__ + "static/logo-9cbf8e862f70f3a5d7ff4123a439ebb6.svg";